<template>
    <transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper centered">
				<div class="modal-container -small">
					<div class="container">
						<div class="modal-header">
							<div class="row">
								<div class="col-8">
									<h1>Need Prime</h1>
								</div>
							</div>
						</div>

						<div class="modal-body">
							<div class="row">
								<div class="col">
									<h5>
										You have selected to have a driver prime your burner. This is an additional $65 charge. 
									</h5>
								</div>
							</div>
							<div class="row">
								<div class="col-auto">
									<button class="btn btn-primary" @click="$emit('confirm')">Yes, confirm prime</button>
								</div>
								<div class="col-auto">
									<button class="btn btn-link" @click="$emit('deny')">No, go back</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </transition>
</template>

<script>
export default {
    data: () => ({
    }),
}
</script>
